// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".OrganisationWrapped-module__section___25mPl{margin-top:20px}.OrganisationWrapped-module__marginTop1rem___3COub{margin-top:1rem}.OrganisationWrapped-module__inputBox___2tmys{border-radius:4px;border:solid 1px #494d56;padding:10px;margin-top:6px;width:100%}.OrganisationWrapped-module__errorMessage___2Z-xS{margin-top:-15px}", ""]);
// Exports
exports.locals = {
	"section": "OrganisationWrapped-module__section___25mPl",
	"marginTop1rem": "OrganisationWrapped-module__marginTop1rem___3COub",
	"inputBox": "OrganisationWrapped-module__inputBox___2tmys",
	"errorMessage": "OrganisationWrapped-module__errorMessage___2Z-xS"
};
module.exports = exports;
